import { useState } from "react";
import PageHeader from "../../../Layout/PageHeader";
import historyIcon from "../../../assets/images/history-icon.svg";
import { useParams } from "react-router-dom";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import Table, { Column } from "../../../Components/Tables/Table";
import { checkInDetailsData, HistoryLaoutDataUnloadDetail } from "../../../Data/testData";
import HistoryLayout from "../../../Layout/HistoryLaout";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";
import ViewMoreModal from "../../../Components/Modals/ViewMoreModal";

export default function UnloadDetails() {
  const { id } = useParams<{ id: string }>();
  const pageName = `Unload (${id})`;
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };
  const viewText = "Handle lorem with care dummy text of the printing and typesetting industry. Lorem Ipsum lorem Ipsum ."
  const [showViewModal, setViewModal] = useState(false);
  const handelViewMoreAction = (data: any) => {
    setViewModal(true);
  };
  const handleViewClose = () => setViewModal(false);
  const onModalSubmit = () => {
    handleViewClose();
  };

  const [isShowCanvas, setShowCanvas] = useState(false);
  const handelCanvas = () => {
   setShowCanvas(!isShowCanvas);
  };
  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );
  const columns: Column[] = [
    {
      name: "Line#",
      selector: (row: { Line: string }) => row.Line,
    },
    {
      name: "Item Code",
      selector: (row: { ItemCode: { imgSrc: string; text: string } }) => (
        <div>
          {row.ItemCode.imgSrc && (
            <img
              src={require(`../../../assets/images/${row.ItemCode.imgSrc}`)}
              alt={row.ItemCode.text}
              style={{ width: "20px", marginRight: "8px" }}
            />
          )}
          {row.ItemCode.text}
        </div>
      ),
    },
    {
      name: "Item Description",
      selector: (row: { ItemDescription: string }) => (
        <span   title={row.ItemDescription.length > 15 ? row.ItemDescription : ""}>
        {row.ItemDescription.length > 15
          ? `${row.ItemDescription.slice(0, 15)}...`
          : row.ItemDescription}
      </span>
      ),
    },
    {
      name: "UOM",
      selector: (row: { UOM: string }) => row.UOM,
    },
    {
      name: "Expected Qty",
      selector: (row: { ExpectedQty: string }) => row.ExpectedQty,
    },
    {
      name: "Backorder Qty",
      selector: (row: { BackorderQty: string }) => row.BackorderQty,
    },
    {
      name: "Received Quantity",
      selector: (row: { ReceivedQuantity: string }) => row.ReceivedQuantity,
    },
  ];

  const InboundASNUnloadData = {
    ASNUnloadExpanded: [
      {
        label: 'PO #', value: (
          <>
            <div className="text-primary cursor-pointer w-fit">20158</div>
          </>
        )
      },
      {
        label: 'Tracking #', value: 1029831
      },
      { label: 'Reference 1', value: "SP2547896" },
      { label: 'Reference 2', value: "6936985" },
      { label: 'Expected Date', value: "03/28/2023" },
      { label: 'Carrier Name', value: "Fedex Ground" },
      { label: 'Created On', value: "07/20/2020" },
      {
        label: 'Special Instructions', value: (
          <>
            {/* Handle with care dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            <div>{"("} <span className="text-primary cursor-pointer">View More</span>{")"}</div> */}
         
         {
            viewText.length > 25 
              ? `${viewText.substring(0, 25)}` 
              : viewText
          }

          {viewText.length > 25 && (
            <div>
              {"("} 
              <span className="text-primary cursor-pointer"  
              onClick={() => handelViewMoreAction(viewText)}
              >View More</span>
              {")"}
            </div>
          )}
          </>
        )
      },
      {
        label: 'Status', value: (
          <>
            <div className="inbound-checkin-status rounded px-4 fs-11 w-auto d-inline-block">
              Ready to Check-In
            </div>
          </>
        )
      }
    ],

   
    ASNUnloadDefault: [
      {
        label: 'PO #', value: (
          <>
            <div className="text-primary cursor-pointer w-fit">20158</div>
          </>
        )
      },
      { label: 'Supplier', value: "John Smith" },
      { label: 'Warehouse', value: "East Houston" }
    ]
  }
  return (
    <>
      <PageHeader
        addUrl="/inbound/asn/unload/add"
        listUrl="/inbound/asn/unload"
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-2 d-flex flex-column">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 ">
          {collapseStates[0] ? (
            <div className="checkin-details align-items-top d-flex bg-white col-12 px-5 ">
              <DynamicDetailGrid customClassName="my-2 col-10" isExpandable={false} columns={3} data={InboundASNUnloadData.ASNUnloadDefault} />

              <div className="col-2">
                <div className="align-self-center d-flex flex-row-reverse my-4">
                  <span
                    className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                    onClick={() => toggleCollapse(0)}
                  >
                    {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="checkin-details flex-column-reverse align-items-center d-flex bg-white px-5 ">
              <div className="d-flex col-12 py-4">
                <div className="d-flex col">
                  <DynamicDetailGrid customClassName="mb-2 pt-0 col" isExpandable={false} columns={2} data={InboundASNUnloadData.ASNUnloadExpanded} />

                </div>
                <div className="col d-flex flex-column justify-content-start align-items-end">
                  <div className="supplier position-relative px-4 py-3 mb-5">
                    <div className="floating-label fs-14 inbound-checkin-supplier position-absolute translate-middle px-2 bg-white">
                      Supplier
                    </div>
                    <div className="name">John Smith</div>
                    <div className="address mt-2">
                      Ship to address 1 <br />
                      Ship to address 2 <br />
                      City, State, Zip Code Country
                    </div>
                  </div>
                  <div className="warehouse position-relative px-4 py-3">
                    <div className="floating-label fs-14 inbound-checkin-warehouse position-absolute translate-middle px-2 bg-white">
                      Warehouse
                    </div>
                    <div className="name">East Houston</div>
                    <div className="address mt-2">
                      Ship to address 1 <br />
                      Ship to address 2 <br />
                      City, State, Zip Code Country
                    </div>
                  </div>
                </div>
                <div className="col-1 ms-3">
                  <div className="align-self-center d-flex flex-row-reverse">

                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse(0)}
                    >
                      {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="my-2 bg-white rounded py-1 px-2">
        <Table
          columns={columns}
          data={checkInDetailsData}
          CheckboxStatus={false}
          isStripped={true}
          customClassName="transferDetailsTable"
        />
      </div>
      <ViewMoreModal
        customClassName="header-border"
        show={showViewModal}
        content={viewText}
        onModalSubmit={onModalSubmit}
      />
      <HistoryLayout  showViewScanLogs={true}  isShowCanvas={isShowCanvas} handelCanvas={handelCanvas} data={HistoryLaoutDataUnloadDetail} />
    </>
  );
}
